import { InputWithTypeahead } from "@dealer-center/ddc-pages-account-search-react";

interface ImportModalAccountInterface {
  setSelectedAccount: (value: string) => void;
}
export const ImportModalAccount = ({
  setSelectedAccount
}: ImportModalAccountInterface) => {
  return (
    <InputWithTypeahead
      filterBy="id"
      placeholder="Account to import from"
      onClearCallback={() => setSelectedAccount("")}
      onItemSelected={account => setSelectedAccount(account)}
      onSubmit={account => setSelectedAccount(account)}
    />
  );
};
